import React from 'react';
import { FormattedMessage } from 'react-intl';
import { AppState } from 'src/AppState';
import { EasyClaimDocumentType } from 'src/easyclaim.api.client.typescript/src';
import { MemoPlaceholderScooterBackRight } from 'src/easyclaim.app.assets/artwork/placeholder/v2/PlaceholderScooterBackRight';
import { reportError } from 'src/easyclaim.app.libs/reportError';

import {
	DetailContainer,
	ExampleModalImage,
	ImageFileInputType,
	SelectImage,
	StyledInfoIcon,
} from '../../easyclaim.app.components/index';
import { Image } from '../../easyclaim.app.services/ImageSelectionService';
import { isAnyOfImagesLoading } from '../FourAdditionalPictures';
import { FourDiagonalPerspectivesProps } from '../FourDiagonalPerspectives';

export function ScooterBackRightControl(currentAppState: FourDiagonalPerspectivesProps) {
	return (
		<>
			<h3 className="four-diagonal-perspectives-vehicle-rear-right-title">
				<FormattedMessage id="fourDiagonalPerspectives.vehicleRearRight.title" />
				<StyledInfoIcon
					className="four-diagonal-perspectives-example-icon four-diagonal-perspectives-vehicle-rear-right-info-icon"
					onClick={() => {
						showExampleModal(currentAppState).catch(reportError);
					}}
				/>
			</h3>
			<DetailContainer>
				<SelectImage
					componentId="vehicleRearRight"
					imageFileInputType={ImageFileInputType.CapturePicture}
					fileType={EasyClaimDocumentType.RearRightPicture}
					caseId={currentAppState.easyClaimCase?.caseId}
					easyClaimService={currentAppState.easyClaimService}
					currentImage={currentAppState.vehicleImageRearRight}
					title="vehicleImages.rightRearOverview"
					placeholder={<MemoPlaceholderScooterBackRight className="photo-placeholder" />}
					marginBottom="1rem"
					onChange={(image) => {
						const newState = vehicleImageChanged(currentAppState, image);

						void currentAppState.setAppState(newState);
					}}
					onShowExample={() => {
						showExampleModal(currentAppState).catch(reportError);
					}}
					showUserFeedbackInfo={true}
					configuration={currentAppState.easyClaimCase!._configuration!}
					inputError={currentAppState.inputError}
					vehicleType={currentAppState.easyClaimCase?.vehicle?.vehicleTypeId}
				/>
			</DetailContainer>
		</>
	);
}

function vehicleImageChanged(currentAppState: AppState, image: Image | undefined): AppState {
	let images: Image[] = [];

	images = currentAppState.vehicleImageFrontLeft
		? images.concat([currentAppState.vehicleImageFrontLeft])
		: images;
	images = currentAppState.vehicleImageRearLeft
		? images.concat([currentAppState.vehicleImageRearLeft])
		: images;
	images = image ? images.concat([image]) : images;
	images = currentAppState.vehicleImageFrontRight
		? images.concat([currentAppState.vehicleImageFrontRight])
		: images;

	const isImageLoading = isAnyOfImagesLoading(images);

	const newState = Object.assign({}, currentAppState, {
		vehicleImageRearRight: image,
		isImageLoading: isImageLoading,
	});

	return newState;
}

function showExampleModal(currentAppState: AppState) {
	const images: ExampleModalImage[] = [
		{ src: `${process.env.PUBLIC_URL}/images/example-policycheck-motorbike-back-right.png` },
	];

	return currentAppState.showExampleModal(
		images,
		'fourDiagonalPerspectives.vehicleRearRight.exampleModalTitle',
		'fourPerspectivesExampleModal.button.close',
		'rear-right-motorbike'
	);
}
